export default function CelebrationParticles({ show }) {
  if (!show) return null;
  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none", zIndex: 100 }}>
      {Array.from({ length: 20 }, (_, i) => (
        <div key={i} style={{
          position: "absolute",
          left: `${Math.random() * 100}%`,
          top: "20%",
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          background: ["#FF6B6B", "#FFE66D", "#4ECDC4", "#A8E6CF", "#FF8B94"][i % 5],
          animation: "confetti 1.5s ease-out forwards",
          animationDelay: `${Math.random() * 0.5}s`,
        }} />
      ))}
    </div>
  );
}
